var _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    fill: "#fff",
    stroke: "#ff0e0e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(7 18)",
    fill: "red",
    fontSize: 17,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!"))));
}
export default __webpack_public_path__ + "e9055a071d5d0b1b23195e81fecf4278.svg";
export { SvgInvalidIcon as ReactComponent };